import apiConfig from '../apiConfig';

export const setDepartmentJobStatus = async (at, departmentJobId, status) => {
	const response = await apiConfig.post(
		'/API/LOOKUPS/DEPARTMENTJOBS/UPD_DEPARTMENT_JOB_ACTIVE',
		{
            Department_Job_Id: departmentJobId,
            Active_Status_Id: status
		},
        {
            headers: {
                Authorization: `Bearer ${at}`,
            },
        },
	);

    return response.data;

}
